import React from "react"

import styled from "styled-components"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faSpinner } from "@fortawesome/free-solid-svg-icons"
import PropTypes from "prop-types"

const LoadingContainer = styled.span`
  border: none;
  background: none;
  color: ${(props) => props.theme.colours.text.secondary};
  padding: 1rem;
`

const LoadingSpinnerInline = ({ text }) => (
  <LoadingContainer>
    <FontAwesomeIcon icon={faSpinner} className={"fa-spin"} />
    {text && " " + text}
  </LoadingContainer>
)

LoadingSpinnerInline.propTypes = {
  text: PropTypes.string,
}

export default LoadingSpinnerInline
